export const formatPrice = (broj) => {
  if (!broj) {
    return '0.00';
  }
  let [deoPreDecimale, deoPosleDecimale] = broj.toString().split('.');
  deoPosleDecimale = deoPosleDecimale || '00';
  deoPreDecimale = deoPreDecimale.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  deoPosleDecimale = deoPosleDecimale.padEnd(2, '0').slice(0, 2);
  return `${deoPreDecimale}.${deoPosleDecimale}`;
};
export const formatNumberSR = (value, options = {}) => {
  if (value === null || value === undefined || value === '') return '';

  const number = Number(value);
  if (Number.isNaN(number)) return value;

  const isInt = Number.isInteger(number);

  return number.toLocaleString('sr-RS', {
    minimumFractionDigits: isInt ? 0 : options.decimals ?? 2,
    maximumFractionDigits: isInt ? 0 : options.decimals ?? 2,
  });
};
